import styled from 'styled-components'
import { ItemContainer } from '../../styles'

export const Container = styled(ItemContainer)`
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
`
